(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6609);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-fade-in/lib/index.js
var lib = __webpack_require__(9925);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./styles/Home.module.scss
var Home_module = __webpack_require__(1633);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./components/Body.tsx


var Body = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Home_module_default()).bodySection,
        children: children
    });
};
/* harmony default export */ var components_Body = (Body);

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
// EXTERNAL MODULE: ./node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(640);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
;// CONCATENATED MODULE: ./components/Icon.tsx



var Icon = function(param) {
    var icon = param.icon, reference = param.reference, _copy = param.copy, copy1 = _copy === void 0 ? false : _copy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            copy1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: function() {
                    return doThings(reference);
                },
                children: icon
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: reference,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Icon",
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hot_toast_esm/* Toaster */.x7, {
                position: "bottom-left",
                reverseOrder: false
            })
        ]
    });
};
var doThings = function(value) {
    copy_to_clipboard_default()(value);
    react_hot_toast_esm/* default.remove */.ZP.remove();
    react_hot_toast_esm/* default.success */.ZP.success("Successfully copied to clipboard", {
        style: {
            background: "#111",
            color: "#fff",
            fontSize: "1.1rem"
        }
    });
};
/* harmony default export */ var components_Icon = (Icon);

;// CONCATENATED MODULE: ./components/IconLayout.tsx


var IconLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Home_module_default()).iconLayout,
            children: children
        })
    });
};
/* harmony default export */ var components_IconLayout = (IconLayout);

;// CONCATENATED MODULE: ./components/MainLayout.tsx


var MainLayout = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Home_module_default()).mainLayout,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: "SkyWatcher_2019"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "17-year-old Russian no-name developer and minecrafter."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Developing Minecraft plugins, Discord bots, and learning website development."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Time to write a new website."
                })
            ]
        })
    });
};
/* harmony default export */ var components_MainLayout = (MainLayout);

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/react-icons/si/index.esm.js
var si_index_esm = __webpack_require__(7735);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
;// CONCATENATED MODULE: ./pages/index.tsx










var Time = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 453).then(__webpack_require__.bind(__webpack_require__, 9453));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9453)
            ];
        }
    },
    ssr: false
});
var Home = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "SkyWatcher_2019"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MainLayout, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_IconLayout, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaGithub */.hJX, {}),
                                    reference: "https://github.com/skywatcher2019",
                                    copy: false
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(si_index_esm/* SiTelegram */.n26, {}),
                                    reference: "https://t.me/skywatcher_2019",
                                    copy: false
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(si_index_esm/* SiDiscord */.Mqf, {}),
                                    reference: "SkyWatcher_2019#5464",
                                    copy: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(si_index_esm/* SiQiwi */.bIy, {}),
                                    reference: "https://qiwi.com/n/skywatcher2019",
                                    copy: false
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 1633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bodySection":"Home_bodySection__VSqx2","mainLayout":"Home_mainLayout__leNH0","iconLayout":"Home_iconLayout__RyCp0","time":"Home_time__nx2B2","weather":"Home_weather__FdOKf","spotify":"Home_spotify___vLf8","tinyText":"Home_tinyText__NQbte","footerLayout":"Home_footerLayout__nXJam"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [415,445,305,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);